interface ServiceSelectionProps {
  selectedServices: string[];
  onServiceToggle: (service: string) => void;
  availableServices?: string[];
}

export default function ServiceSelection({ selectedServices, onServiceToggle, availableServices }: ServiceSelectionProps) {
  const services = [
    {
      id: 'nail',
      name: '네일아트',
      icon: 'ri-hand-heart-line',
      description: '젤네일, 아트네일, 케어'
    },
    {
      id: 'eyelash',
      name: '속눈썹',
      icon: 'ri-eye-line',
      description: '속눈썹 연장, 펌'
    },
    {
      id: 'waxing',
      name: '왁싱',
      icon: 'ri-heart-pulse-line',
      description: '전신 왁싱, 부분 왁싱'
    },
    {
      id: 'skincare',
      name: '피부관리',
      icon: 'ri-heart-3-line',
      description: '페이셜, 클렌징, 관리'
    },
    {
      id: 'hair',
      name: '헤어',
      icon: 'ri-scissors-cut-line',
      description: '컷, 펌, 염색'
    },
    {
      id: 'makeup',
      name: '메이크업',
      icon: 'ri-brush-line',
      description: '데일리, 웨딩, 특수'
    }
  ];

  const isServiceAvailable = (serviceId: string) => {
    if (!availableServices) return true;
    return availableServices.includes(serviceId);
  };

  return (
    <section className="mb-12">
      <div className="bg-white rounded-3xl p-8 shadow-lg">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-rose-400 to-pink-400 rounded-full">
            <i className="ri-service-line text-white text-lg"></i>
          </div>
          <div>
            <h2 className="text-2xl font-medium text-gray-800">서비스 선택</h2>
            <p className="text-sm text-gray-600">원하는 서비스를 선택해주세요 (복수 선택 가능)</p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {services.map((service) => {
            const isAvailable = isServiceAvailable(service.id);
            const isSelected = selectedServices.includes(service.id);
            
            return (
              <button
                key={service.id}
                onClick={() => isAvailable && onServiceToggle(service.id)}
                disabled={!isAvailable}
                className={`p-6 rounded-2xl border-2 transition-all text-left ${
                  !isAvailable
                    ? 'border-gray-200 bg-gray-50 opacity-50 cursor-not-allowed'
                    : isSelected
                    ? 'border-rose-400 bg-gradient-to-br from-rose-50 to-pink-50 shadow-md cursor-pointer'
                    : 'border-gray-200 hover:border-rose-300 hover:shadow-md bg-white cursor-pointer'
                }`}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
                    !isAvailable
                      ? 'bg-gray-200'
                      : isSelected
                      ? 'bg-gradient-to-r from-rose-400 to-pink-400'
                      : 'bg-rose-50'
                  }`}>
                    <i className={`${service.icon} text-xl ${
                      !isAvailable
                        ? 'text-gray-400'
                        : isSelected
                        ? 'text-white'
                        : 'text-rose-400'
                    }`}></i>
                  </div>
                  {isSelected && isAvailable && (
                    <div className="w-6 h-6 flex items-center justify-center bg-gradient-to-r from-rose-400 to-pink-400 rounded-full">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                  )}
                  {!isAvailable && (
                    <div className="w-6 h-6 flex items-center justify-center bg-gray-300 rounded-full">
                      <i className="ri-close-line text-white text-sm"></i>
                    </div>
                  )}
                </div>
                <h3 className={`text-base font-medium mb-1 ${
                  !isAvailable ? 'text-gray-400' : 'text-gray-800'
                }`}>
                  {service.name}
                </h3>
                <p className={`text-xs ${
                  !isAvailable ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  {service.description}
                </p>
                {!isAvailable && (
                  <p className="text-xs text-gray-500 mt-2">이 매장에서 제공하지 않는 서비스입니다</p>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
